import React from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { LocalMallOutlined } from '@mui/icons-material';

import best1 from '../../assets/new1.avif';
import best2 from '../../assets/new2.avif';
import new1 from '../../assets/new3.avif';
import new2 from '../../assets/new4.avif';
import new3 from '../../assets/new5.avif';
import new4 from '../../assets/new6.avif';
import new5 from '../../assets/new7.avif';

const products = [
    {
        title: "Elegant Silk Saree with Zari Border",
        price: "₹10,499.00",
        image: best1
    },
    {
        title: "Contemporary Palazzo Suit Set",
        price: "₹8,250.00",
        image: best2
    },
    {
        title: "Hand-Embroidered Ethnic Wear",
        price: "₹9,190.00",
        image: new1
    },
    {
        title: "Modern Kurta Set",
        price: "₹7,150.00",
        image: new2
    },
    {
        title: "Pure Silk Designer Suit Set",
        price: "₹12,499.00",
        image: new3
    },
    {
        title: "Floral Print Maxi Dress",
        price: "₹5,499.00",
        image: new4
    },
    {
        title: "Traditional Fusion Wear",
        price: "₹6,590.00",
        image: new5
    }
];

const BestSellers = () => {
    return (
        <Box sx={{ py: 12, backgroundColor: '#FAF9F6' }}>
            <Container maxWidth="xl">
                <Grid container spacing={6} alignItems="flex-start">
                    {/* Left Content Side - STICKY */}
                    <Grid item size={{ xs: 12, md: 4 }} sx={{ position: { md: 'sticky' }, top: { md: '120px' }, zIndex: 10 }}>
                        <Box sx={{ ml: 'auto', maxWidth: '400px', pr: { md: 4 } }}>
                            <Typography
                                sx={{
                                    fontFamily: "'Sora', sans-serif",
                                    fontSize: '0.75rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.2em',
                                    color: '#A68B77',
                                    textTransform: 'uppercase',
                                    mb: 1
                                }}
                            >
                                Customer Favorites
                            </Typography>
                            <Typography
                                variant="h2"
                                sx={{
                                    fontFamily: "'cormorantgaramond', serif",
                                    fontWeight: 700,
                                    fontSize: { xs: '3rem', md: '4.5rem' },
                                    color: '#1a1a1a',
                                    lineHeight: 1,
                                    mb: 4
                                }}
                            >
                                Best<br />Sellers
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: "'Sora', sans-serif",
                                    fontSize: '1rem',
                                    color: '#444',
                                    lineHeight: 1.8,
                                    mb: 5,
                                    maxWidth: '320px'
                                }}
                            >
                                Our most loved pieces, curated by our community of stylish women. Don't miss out on these trending essentials.
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#333',
                                    color: 'white',
                                    borderRadius: 0,
                                    px: 4,
                                    py: 2,
                                    fontFamily: "'Sora', sans-serif",
                                    fontSize: '0.75rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.1em',
                                    '&:hover': {
                                        backgroundColor: '#000',
                                    }
                                }}
                            >
                                SHOP ALL BEST SELLERS
                            </Button>
                        </Box>
                    </Grid>

                    {/* Right Products Side */}
                    <Grid item size={{ xs: 12, md: 8 }}>
                        <Grid container spacing={0} alignItems="flex-start">
                            {products.map((product, index) => (
                                <Grid
                                    item
                                    size={{ xs: 12, sm: 6 }}
                                    key={index}
                                    sx={{
                                        pt: index % 2 !== 0 ? { sm: 12 } : 0,
                                        mb: 8
                                    }}
                                >
                                    <Box
                                        component={motion.div}
                                        initial={{ opacity: 0, scale: 0.9, y: 50 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        viewport={{ once: true, amount: 0.5, margin: "0px 0px -50px 0px" }}
                                        transition={{
                                            duration: 0.8,
                                            ease: [0.22, 1, 0.36, 1],
                                            delay: (index % 2) * 0.1
                                        }}
                                        sx={{
                                            textAlign: 'center',
                                            maxWidth: '400px',
                                            ml: index % 2 === 0 ? 'auto' : 2,
                                            mr: index % 2 === 0 ? 2 : 'auto',
                                            cursor: 'pointer',
                                            '&:hover .cart-button': {
                                                opacity: 1,
                                                transform: 'translateY(0)'
                                            }
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: '100%',
                                                paddingTop: '140%',
                                                backgroundColor: '#f5f5f5',
                                                mb: 3,
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 15,
                                                    right: 15,
                                                    backgroundColor: '#C4B6A6',
                                                    px: 1.5,
                                                    py: 0.5,
                                                    fontSize: '0.65rem',
                                                    fontFamily: "'Sora', sans-serif",
                                                    fontWeight: 600,
                                                    letterSpacing: '0.1em',
                                                    color: 'white',
                                                    zIndex: 1
                                                }}
                                            >
                                                TRENDING
                                            </Box>
                                            <Box
                                                component="img"
                                                src={product.image}
                                                alt={product.title}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    transition: 'transform 0.6s ease-in-out',
                                                    '&:hover': {
                                                        transform: 'scale(1.05)'
                                                    }
                                                }}
                                            />
                                            {/* Cart Button */}
                                            <Box
                                                className="cart-button"
                                                sx={{
                                                    position: 'absolute',
                                                    bottom: 20,
                                                    right: 20,
                                                    width: '45px',
                                                    height: '45px',
                                                    borderRadius: '50%',
                                                    border: '2px solid white',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    opacity: 0,
                                                    transform: 'translateY(10px)',
                                                    transition: 'all 0.3s ease-in-out',
                                                    zIndex: 2,
                                                    '&:hover': {
                                                        backgroundColor: '#D4A0A6',
                                                        borderColor: '#D4A0A6',
                                                        color: 'white'
                                                    }
                                                }}
                                            >
                                                <LocalMallOutlined sx={{ fontSize: '1.2rem' }} />
                                            </Box>
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontFamily: "'cormorantgaramond', serif",
                                                fontWeight: 700,
                                                fontSize: '1.5rem',
                                                color: '#1a1a1a',
                                                mb: 1,
                                                lineHeight: 1.2
                                            }}
                                        >
                                            {product.title}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontFamily: "'Sora', sans-serif",
                                                fontWeight: 600,
                                                fontSize: '0.85rem',
                                                color: '#666'
                                            }}
                                        >
                                            {product.price}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Container >
        </Box >
    );
};

export default BestSellers;
